import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { SystemService } from '../../services/system.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { UsersService } from '../../services/users.service';
import { GlobalsService } from '../../services/globals.service';

@Component({
	selector: 'app-system-notice',
	templateUrl: './system-notice.component.html',
	styleUrls: ['./system-notice.component.scss']
})
export class SystemNoticeComponent implements OnInit {
	noticeForm: UntypedFormGroup;
	color = 'blue';
	userGroups: any[] = [];
	locations: any[] = [];
	notices: any[] = [];

	editingNotice: any = null;

	constructor(private fb: UntypedFormBuilder,
				private systemService: SystemService,
				private globalSearchService: GlobalSearchService,
				private usersService: UsersService,
				private globalsService: GlobalsService,
				private location: Location) {
		this.color = this.globalSearchService.getColor();
		this.noticeForm = this.fb.group({
			message: ['', Validators.required],
			priority: [0, Validators.required],
			groups: [[]],
			locations: [[]]
		});
	}

	ngOnInit(): void {
		this.loadLists();
		this.loadNotices();
	}

	loadLists() {
		this.usersService.getUserGroups().subscribe((groups: any) => {
			this.userGroups = groups;
		});

		this.globalsService.getAllLocations().subscribe((locs: any) => {
			this.locations = locs;
		});
	}

	loadNotices() {
		this.systemService.getSystemNotice().subscribe((result: any[]) => {
			if (Array.isArray(result)) {
				this.notices = result.map(n => ({
					...n,
					groups: JSON.parse(n.groups || '[]'),
					locations: JSON.parse(n.locations || '[]')
				}));
			}
		});
	}


	saveNotice() {
		if (this.noticeForm.invalid) {return;}

		const data = { ...this.noticeForm.value };

		if (this.editingNotice) {
			// Update
			data.id = this.editingNotice.id;
			this.systemService.updateSystemNotice(data).subscribe(() => {
				this.globalSearchService.showNotification('Notice Updated', 'info', 'bottom', 'right');
				this.resetForm();
				this.loadNotices();
			});
		} else {
			// Create
			this.systemService.saveSystemNotice(data).subscribe(() => {
				this.globalSearchService.showNotification('Notice Saved', 'success', 'bottom', 'right');
				this.resetForm();
				this.loadNotices();
			});
		}
	}

	editNotice(n: any) {
		this.editingNotice = n;
		this.noticeForm.patchValue({
			message: n.message,
			priority: n.priority || 0,
			groups: n.groups || [],
			locations: n.locations || []
		});
	}

	deleteNotice(n: any) {
		if (!confirm('Delete this notice?')) {return;}

		const data = {
			id: n.id
		}

		this.systemService.deleteSystemNotice(data).subscribe(() => {
			this.globalSearchService.showNotification('Notice Deleted', 'warning', 'bottom', 'right');
			this.loadNotices();
			this.resetForm();
		});
	}

	cancelEdit() {
		this.resetForm();
	}

	resetForm() {
		this.editingNotice = null;
		this.noticeForm.reset({ message: '', priority: 0, groups: [], locations: [] });
	}

	back(): void {
		this.location.back();
	}
}